export const IDNOW_ELIGIBILITY = "IDNOW_ELIGIBILITY";
export const INITIATE_IDNOW = "INITIATE_IDNOW";
export const IDNOW_GET_DETAILS = "IDNOW_GET_DETAILS";

export const SET_IDNOW_DETAILS = "SET_IDNOW_DETAILS";

export const UPDATE_USER_BY_ADMIN = "UPDATE_USER_BY_ADMIN";
export const REFETCH_IDNOW_DETAILS = "REFETCH_IDNOW_DETAILS";